class AureyVisualMenuV54 extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.querySelectorAll('[data-avm54-category]').forEach((link) => {
      link.addEventListener('mouseenter', () => this.activate(link));
      link.addEventListener('focus', () => this.activate(link));
    });
  }

  activate(activeLink) {
    const index = activeLink.dataset.avm54Category;
    this.querySelectorAll('[data-avm54-category]').forEach((link) => {
      const active = link === activeLink;
      link.classList.toggle('is-active', active);
      link.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
    this.querySelectorAll('[data-avm54-panel]').forEach((panel) => {
      const active = panel.dataset.avm54Panel === index;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }
}

if (!customElements.get('aurey-visual-menu-v54')) {
  customElements.define('aurey-visual-menu-v54', AureyVisualMenuV54);
}
